<template>
  <transition name="modal" appear v-if="open">
    <div class="modal modal-overlay" @mousedown.self="$emit('close')">
      <div class="pop_layer" style="display: block">
        <div class="pop_titbox">
          <h4 class="pop_tit">{{ title }}</h4>
          <div class="pop_close"><a class="close" @click="$emit('close')">닫기</a></div>
        </div>
        <div class="pop_cont">
          <div class="modal-content">
            <slot />
          </div>
          <footer class="modal-footer">
            <slot name="footer">
              <!-- <button @click="$emit('close')">Close</button> -->
            </slot>
          </footer>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: ['open', 'title'],
  watch: {
    open(to) {
      this.preventBodyScroll(to);
    },
  },
  methods: {
    preventBodyScroll(modalShow) {
      if (modalShow) {
        document.body.style.cssText = `
          position: fixed; 
          top: -${window.scrollY}px;
          overflow-y: scroll;
          width: 100%;`;
      } else {
        const scrollY = document.body.style.top;
        document.body.style.cssText = '';
        window.scrollTo(0, parseInt(scrollY || '0', 10) * -1);
      }
    },
  },
  destroyed() {
    this.preventBodyScroll(false);
  },
};
</script>
<style lang="scss" scoped>
.modal {
  &.modal-overlay {
    position: fixed;
    z-index: 10;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
  }

  & .pop_layer {
    background: #fff;
    border-radius: 4px;
    overflow: hidden;
  }
  @media (max-width: 540px) {
    .pop_layer {
      height: 85%;
    }
  }
  @media (max-height: 600px) {
    .pop_layer {
      height: 95%;
    }
  }

  &-content {
    padding: 20px 20px 5px;
    min-height: calc(100% - 62px);
  }

  &-footer {
    position: sticky;
    bottom: 0;
    background: #fff;
    padding: 5px 0 0;

    ::v-deep {
      & .btn_bg {
        line-height: 45px;
      }

      .all-half {
        width: calc(50% - 5px);
        min-width: calc(50% - 5px);
        margin: 0;
        flex: 1;
      }
    }
  }

  & .pop_close {
    cursor: pointer;
  }

  & .pop_cont {
    padding: 0;
  }
}

// 오버레이 트랜지션
.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.3s;

  // 오버레이에 포함되어 있는 모달 윈도의 트랜지션
  .modal-window {
    transition: opacity 0.2s, transform 0.2s;
  }
}

// 딜레이가 적용된 모달 윈도가 제거된 후에 오버레이가 사라짐
.modal-leave-active {
  transition: opacity 0.2s ease 0.2s;
}

.modal-enter,
.modal-leave-to {
  opacity: 0;

  .modal-window {
    opacity: 0;
    transform: translateY(-20px);
  }
}
</style>
